/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { Typography, FormControl, TextField } from '@mui/material';
import get from "lodash/get";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import { useEffect } from 'react';
import dayjs from 'dayjs';

const DatePickerUi = ({ children, formik, name, label, disabled, labelInput = null, ...props }) => {
    const [value, setValue] = useState(null)
    moment.locale("es")

    const onChange = (e) => {
        setValue(e)
       // console.log("Retorno al Formik con este valor: ",e.format())
        formik.setFieldValue([name], e.format())
    }
    useEffect(() => {
        setValue(dayjs(get(formik, `values.[${name}]`)))
       // console.log("Entre: ",get(formik, `values.[${name}]`));
    }, [])

    return (
        <FormControl fullWidth >
            {!labelInput &&
                <Typography className='pb-2 pl-4' component="label" htmlFor="username" color={disabled ? "text.lite" : "text.main"} >
                    {label}
                </Typography>
            }
            <DatePicker
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                disabled={disabled}
                {...props}
                {...(labelInput ? { label } : {})}
            />
        </FormControl>
    )
}

export default DatePickerUi